export default __webpack_public_path__ + "static/media/Flag_of_Jamaica.dc02037b.svg";